/**
 * lib/experiences/launchFlags.ts
 * ─────────────────────────────────────────────────────────────────────────────
 * Provider-Only Marketplace & Comparison V2 Foundation — Part B.
 *
 * Mirrors the backend's engine/supply_integration/supply_flags.py
 * is_show_local_references_enabled() exactly: absence of the variable is
 * equivalent to "false" (the launch default — provider-only marketplace).
 * The backend is the actual source of truth for WHAT gets returned
 * (/experiences/search already hides local items and their counts when its
 * own RHEA_SHOW_LOCAL_REFERENCES is off, regardless of what this frontend
 * flag says) — this flag only controls two things the backend can't:
 *   1. the OLD /experiences/sequence-based fallback path (used when
 *      /experiences/search fails or hasn't answered yet), which still
 *      returns marketplace_inventory with local items mixed in;
 *   2. whether launch-mode-only UI (the "Con proveedor" toggle, which is
 *      redundant once provider-only is the default) is shown at all.
 */
export function isShowLocalReferencesEnabled(): boolean {
  try {
    const raw = (import.meta.env.VITE_RHEA_SHOW_LOCAL_REFERENCES as string | undefined) ?? "false";
    return raw.trim().toLowerCase() === "true";
  } catch {
    return false;
  }
}

/** Enables the existing Planner preview only in the staging build. */
export function isPlannerPreviewEnabled(): boolean {
  try {
    const env = (import.meta.env.VITE_RHEA_ENV as string | undefined) ?? "";
    const raw = (import.meta.env.VITE_RHEA_PLANNER_PREVIEW_ENABLED as string | undefined) ?? "false";
    return env.trim().toLowerCase() === "staging" && raw.trim().toLowerCase() === "true";
  } catch {
    return false;
  }
}
